import React from 'react';
import './ToolsCard.scss';

export default function ToolsCard({ icon, title, description }) {
  return (
    <div className='tools-card-container'>
      <div className='icon-container'>
        <img src={icon} alt="icon" />
      </div>
      <div className='feature-info'>
        <h4>{title}</h4>
        <p>
          {description}
        </p>
      </div>
    </div>
  );
}
